import axios from "axios";

export const getSingleSurveyService = async (id) => {
    const { data } = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/surveys/singleSurvey/${id}`);
    return data;
}

export const deleteTeamsSurveyLiveCard = async ({id, tenantId, messageId, userId}) => {
    let url = `https://pulsesurvedeve7ed5fbot.azurewebsites.net/api/notify/${tenantId}/${id}?batabot_deletecard=${messageId}&userId=${userId}`
    let res = await axios.get(url);
    return res;
}

export const storeBatabotCallRating = async (body) => {
    const { data } = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/batabot`, body);
    return data;
}
